import { ApiClient } from '@provider-portal/common/api';
import { createFetcher } from '@provider-portal/common/api/apiFetcher/createFetcher';

import { PromotionsApiFetchers } from './types';

export const createPromotionsApiFetchers = (api: ApiClient): PromotionsApiFetchers => {
  const apiClient = api.deliveryCampaignProvider;
  return {
    getProviderEligibilityData: createFetcher({
      name: 'promotions.getProviderEligibilityData',
      fetch: apiClient.getProviderEligibilityData.bind(apiClient),
    }),
    weeklyForecasts: createFetcher({
      name: 'promotions.weeklyForecasts',
      fetch: apiClient.getWeeklyForecast.bind(apiClient),
    }),
    availableRecommendationsAndFocuses: createFetcher({
      name: 'promotions.availableRecommendationsAndFocuses',
      fetch: apiClient.getRecommendationsAndFocuses.bind(apiClient),
    }),
    getTestFlags: createFetcher({
      name: 'promotions.getTestFlags',
      fetch: apiClient.getTestFlags.bind(apiClient),
    }),
    availableSelfServiceOptions: createFetcher({
      name: 'promotions.availableSelfServiceOptions',
      fetch: apiClient.getAvailablePromotionsOptionsTree.bind(apiClient),
    }),
    list: createFetcher({
      name: 'promotions.list',
      fetch: apiClient.getAssignedPromotions.bind(apiClient),
    }),
    details: createFetcher({
      name: 'promotions.details',
      fetch: apiClient.getPromotionDetails.bind(apiClient),
    }),
    singIn: createFetcher({
      name: 'promotions.signIn',
      fetch: apiClient.signUpPromotion.bind(apiClient),
    }),
    singOut: createFetcher({
      name: 'promotions.signOut',
      fetch: apiClient.cancelPromotionRegistration.bind(apiClient),
    }),
    storeAnalyticsEvent: createFetcher({
      name: 'promotions.storeAnalyticsEvent',
      fetch: apiClient.storeAnalyticsEvent.bind(apiClient),
    }),
    fetchPromotionsPermissions: createFetcher({
      name: 'promotions.fetchPromotionsPermissions',
      fetch: apiClient.getPromotionsPermissions.bind(apiClient),
    }),
    getMenuItemsForProviderActiveMenu: createFetcher({
      name: 'promotions.getMenuItemsForProviderActiveMenu',
      fetch: api.deliveryProviderPortal.getMenuItemsForProviderActiveMenu.bind(
        api.deliveryProviderPortal,
      ),
    }),
    fetchSelfServiceCampaignMeta: createFetcher({
      name: 'promotions.fetchSelfServiceCampaignMeta',
      fetch: apiClient.getSelfServiceCampaignMeta.bind(apiClient),
    }),
    updateMenuItemsForPromotion: createFetcher({
      name: 'promotions.updateMenuItemsForPromotion',
      fetch: apiClient.updateMenuItemsForPromotion.bind(apiClient),
    }),
    getCityExclusionTags: createFetcher({
      name: 'promotions.getCityExclusionTags',
      fetch: apiClient.getCityExclusionTags.bind(apiClient),
    }),
  };
};
